import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Import components and pages
import SuperAdminLogin from './pages/superadminlogin.js';
import AdminLogin from './pages/AdminLogin';
import ForgotPassword from './pages/ForgotPassword';
import StudentForgotPassword from './pages/StudentForgotPassword';
import Dashboard from './pages/Dashboard';
import AddStudent from './components/AddStudent';
import StudentQuiz from './pages/StudentQuiz';
import StudentLogin from './pages/StudentLogin';
import StudentRegister from './pages/StudentRegister';
import StudentDashboard from './pages/StudentDashboard';
import StudentMark from './pages/StudentMarkDashboard';
import ResultPieChart from './pages/ResultPieChart';
import Result from './pages/Result';
import ProtectedStudentRoute from './components/ProtectedStudentRoute';
import QuestionTable from './pages/QuestionTable';
import StudentTestPage from './pages/StudentTestPage';
import StudentsList from './pages/StudentsList';
import BulkUploadQuestions from './pages/BulkUploadQuestions';
import PaymentPage from './pages/PaymentPage';
import StudentPayments from './pages/StudentPayments';
import StudentAccount from './pages/StudentAccount';
import GenerateTestPage from './pages/GenerateTestPage';
import TakeTestPage from './pages/TakeTestPage';
import TestResultPage from './pages/TestResultPage';
import AdminCompletedTestsPage from './pages/AdminCompletedTestsPage';
import AddNewSection from './pages/AddNewSection';
import AllPayments from './pages/AllPayments.js';
import StoredTestResultPage from './pages/StoredTestResultPage';
import StudentResetPassword from './components/StudentResetPassword';
import Addadmin from './pages/Addadmin.js';
import AdminDashboard from './pages/AdminDashboard';
import AdminAddStudent from './pages/AdminAddStudent';
import AdminStudentList from './pages/AdminStudentList';
import AdminStudentResult from './pages/AdminStudentResult';
import MyAccount2 from './pages/MyAccount2';
import ProtectedAdminRoute from './components/ProtectedAdminRoute'; // Added missing import

function App() {
  return (
    <Router>
      <div className="app-container">
        {/* 🔒 Admin Routes */}
        <Routes>
          <Route path="/" element={<Navigate to="/admin-login" />} />
          <Route path="/super-admin" element={<SuperAdminLogin />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/questions" element={<QuestionTable />} />
          <Route path="/addadmin" element={<Addadmin />} />
          <Route path="/add-student" element={<AddStudent />} />
          <Route path="/quiz" element={<StudentQuiz />} />
          <Route path="/add" element={<BulkUploadQuestions />} />
          <Route path="/students-list" element={<StudentsList />} />
          <Route path="/all-completed-Tests" element={<AdminCompletedTestsPage />} />
          <Route path="/add-section" element={<AddNewSection />} />
          <Route path="/allPayments" element={<AllPayments />} />
          <Route path="/admin/stored-result/:testId" element={<StoredTestResultPage />} />

          {/* 🔒 New Admin Routes for AdminDashboard and AdminSidebar2 */}
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<ProtectedAdminRoute><AdminDashboard /></ProtectedAdminRoute>} />
          <Route path="/admin/add-student" element={<ProtectedAdminRoute><AdminAddStudent /></ProtectedAdminRoute>} />
          <Route path="/admin/students-list" element={<ProtectedAdminRoute><AdminStudentList /></ProtectedAdminRoute>} />
          <Route path="/admin/all-completed-tests" element={<AdminStudentResult />} />
          <Route path="/admin/my-account" element={<MyAccount2 />} />

          {/* 👤 Student Public Routes */}
          <Route path="/student-login" element={<StudentLogin />} />
          <Route path="/register" element={<StudentRegister />} />
          <Route path="/student-forgot-password" element={<StudentForgotPassword />} />

          {/* 🔐 Protected Student Routes */}
          <Route path="/student-dashboard" element={<ProtectedStudentRoute><StudentDashboard /></ProtectedStudentRoute>} />
          <Route path="/result" element={<ProtectedStudentRoute><Result /></ProtectedStudentRoute>} />
          <Route path="/studentmark-dashboard" element={<ProtectedStudentRoute><StudentMark /></ProtectedStudentRoute>} />
          <Route path="/result-summary" element={<ProtectedStudentRoute><ResultPieChart /></ProtectedStudentRoute>} />
          <Route path="/Payment-student" element={<StudentPayments />} />
          <Route path="/generate-test" element={<GenerateTestPage />} />
          <Route path="/take-test/:testId" element={<TakeTestPage />} />
          <Route path="/test-result" element={<TestResultPage />} />
          <Route path="/profile" element={<StudentAccount />} />
          <Route path="/payment/:testAttemptId" element={<PaymentPage />} />
          <Route path="/stored-result/:testId" element={<StoredTestResultPage />} />
          <Route path="/reset-password/:token" element={<StudentResetPassword />} />

          {/* 📝 Test Pages */}
          <Route path="/student/test/:testId" element={<ProtectedStudentRoute><StudentTestPage /></ProtectedStudentRoute>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;